import React from 'react';
import PropTypes from 'prop-types';

const ValidationMessage = ({ message, valid, wasValidated, style }) => (
  <React.Fragment>
    { wasValidated && !valid && (
      <div className="invalid-feedback" style={style}>
        {message}
      </div>
    )
    }
  </React.Fragment>
);

ValidationMessage.defaultProps = {
  wasValidated: true,
};

ValidationMessage.propTypes = {
  message: PropTypes.string,
  valid: PropTypes.bool.isRequired,
  wasValidated: PropTypes.bool,
};

export default ValidationMessage;



// WEBPACK FOOTER //
// ./src/components/validation/ValidationMessage.jsx